import { QuestionBase } from './question-base.model';

export class RatingQuestion extends QuestionBase<string> {
    controlType = 'rating';
    id: string;
    disabled: boolean;
    visible: string;
    options: any;
    type: any;
    req_stars: any;
    constructor(options: {} = {}) {
        super(options);
        this.value = options['value'] || false;
        this.id = options['id'];
        this.disabled = options['disabled'] || false;
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
        this.options = options['options'];
        this.type = options['type'];
        this.req_stars = options['req_stars'];
    }
}